<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <img
        :src="require('@/assets/images/logo/logo.png')"
        style="width:30px"
      >
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https:glogc.com"
        target="_blank"
      >GOBUILDERS NETSOFT SDN BHD (1232479-T) , All Rights Reserved</b-link>
    </span>

    <span class="float-md-right d-none d-md-block">
      <b-link @click="openModal('https://docs.google.com/gview?url=https://gologspace.sgp1.cdn.digitaloceanspaces.com/misc_files/REFUND_POLICY.docx&embedded=true', 'Refund Policy')" class="ml-25 text-primary" href="#">
        Refund Policy
      </b-link>
      |
      <b-link @click="openModal('https://docs.google.com/gview?url=https://gologspace.sgp1.cdn.digitaloceanspaces.com/misc_files/DATA_PRIVACY_POLICY.docx&embedded=true', 'Data Privacy Policy')" class="ml-25 text-primary" href="#">
        Data Privacy Policy
      </b-link>
      |
      <b-link @click="openModal('https://docs.google.com/gview?url=https://gologspace.sgp1.cdn.digitaloceanspaces.com/misc_files/RULES_CONDUCT_POLICY.docx&embedded=true', 'Rules & Conduct Policy')" class="ml-25 text-primary" href="#">
        Rules & Conduct Policy
      </b-link>
      |
      <b-link @click="openModal('https://docs.google.com/gview?url=https://gologspace.sgp1.cdn.digitaloceanspaces.com/misc_files/PRIVACY_TERMS_POLICY.docx&embedded=true', 'Privacy Terms Policy')" class="ml-25 text-primary" href="#">
        Privacy Terms Policy
      </b-link>
      |
      <b-link class="ml-25 text-primary" href="#">
        (CONTACT US: 0172881735)
      </b-link>
    </span>

    <b-modal v-model="showModal" :title="modalTitle" size="lg" hide-footer>
      <iframe
        :src="docUrl"
        width="100%"
        height="750px"
        frameborder="0"
      ></iframe>
    </b-modal>
  </p>
</template>

<script>
import { BLink, BModal } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BModal,
  },
  data() {
    return {
      showModal: false,
      docUrl: '',
      modalTitle: '', 
    }
  },
  methods: {
    openModal(url, title) {
      this.docUrl = url;
      this.modalTitle = title;
      this.showModal = true;
    }
  }
}
</script>